import React, { useContext, useEffect, useState } from "react"
import RejLoansComp from "../Loan/RejectedLoans"
import RefferedLoans from "../Loan/RefferedLoans"
import DisLoansComp from "../Loan/DisbursedLoans"
import TabHeader from "../TabHeader"
import ApprovedLoans from "../Loan/ApprovedLoans"
import MemoLoans from "../Loan/RefferedLoans/MemoLoans"
import { AuthContext } from "context/AuthContext"
import { useSearchParams } from "react-router-dom"
// import ApprovedLoans from "components/Dashboard/Loan/ApprovedLoans/index"


const tabs = [
	{label:"Reffered Loans",index:1},
	{label:"Accepted Loans",index:2},
	{label:"Memo Loans",index:3},
	{label:"Approved Loans",index:4},
	{label:"Disbursed Loans",index:5},
	{label:"Rejected Loans",index:6},
]
export default function LPHTabs() {
    const {adminProfile} = useContext(AuthContext)
	const adminRole = adminProfile?.admin_role
	const [toggleState, setToggleState] = useState(1)

	const [params,setParams] = useSearchParams()

	const handleSetTab = (tab)=>{
		setParams({tab})
		setToggleState(tab)
	}

	useEffect(()=>{
		const currentTab = params.get("tab")
		if(currentTab){
			setToggleState(parseInt(currentTab))
		}
	},[params])



	return (
		<div>
			<TabHeader tabs={tabs} currentTab={toggleState} selectTab={handleSetTab}/>
			<div className="">
				{toggleState === 1 && (<RefferedLoans admin_role={adminRole} user={adminProfile} />)}
				{toggleState === 2 && (<RefferedLoans admin_role={adminRole} user={adminProfile} is_accepted/>)}
				{toggleState === 3 && (<MemoLoans admin_role={adminRole} user={adminProfile} />)}
				{toggleState === 4 && (<ApprovedLoans />)}
				{toggleState === 5 && (<DisLoansComp />)}
				{toggleState === 6 && (<RejLoansComp />)}
			</div>
		</div>
	)
}

